export const authConstants = {
    ADMIN_LOGGED_IN: 'ADMIN_LOGGED_IN',
    ADMIN_LOGGED_OUT: 'ADMIN_LOGGED_OUT',

    ADMIN_2FA_VERIFY: 'ADMIN_2FA_VERIFY',
    ADMIN_2FA_NOT_VERIFY: 'ADMIN_2FA_NOT_VERIFY',

    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',

    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'LOGOUT_FAILURE',

    // check if user already loggedin
    AUTH_REQUEST: 'AUTH_REQUEST',
    AUTH_SUCCESS: 'AUTH_SUCCESS',
    AUTH_FAILURE: 'AUTH_FAILURE',

    // redirect after login
    AUTH_LOGIN_REDIRECT: 'AUTH_LOGIN_REDIRECT'
}


// WEBPACK FOOTER //
// ./src/constants/auth.js